import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarData } from '../models/snack-bar-data.model';
import { SnackBarComponent } from '@shared/components/snack-bar/snack-bar.component';
import { BehaviorSubject } from 'rxjs';
import { SnackBarType } from '@core/enums/snack-bar-type.enum';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
    private _skipSnackbarCloseUrl = new BehaviorSubject<string | null>(null);

    constructor(
        private readonly _snackBar: MatSnackBar,
    ) {}

    setSkipSnackbarCloseUrl(url: string | null){
        this._skipSnackbarCloseUrl.next(url);
    }

    successMessage(message: string, params?: Record<string, string>){
        const data: SnackBarData = {
                message,
                type: SnackBarType.SUCCESS,
                duration: 3000,
                params,
        }
        this.openFromComponent(data);
    }

    errorMessage(message: string, params?: Record<string, string>){
        const data: SnackBarData = {
                message,
                type: SnackBarType.ALERT,
                params,
        }
        this.openFromComponent(data);
    }

    open(data: SnackBarData){
        this.openFromComponent(data);
    }

    private openFromComponent(data: SnackBarData){
        this._snackBar.openFromComponent(SnackBarComponent, {
            data,
            duration: data.duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['custom-snackbar', `snackbar-${data.type}`],
        });
    }

    close(url?: string){
        const skipSnackbarCloseUrl = this._skipSnackbarCloseUrl.getValue();
        if(url !== undefined && skipSnackbarCloseUrl != null && url === skipSnackbarCloseUrl){
            this.setSkipSnackbarCloseUrl(null);
            return;
        }
        this._snackBar.dismiss();
    }
}
